import ToastList from './toast-list';

export default function Toasts() {
  return <ToastList />;
}
